let getters = {
  sessionId(state){
    return state.sessionId
  },
  user(state){
    return state.user
  }
}
export default getters



// WEBPACK FOOTER //
// ./src/store/login/getters.js